import axios from "axios";

export const engApi = axios.create({
  baseURL: "https://eng.buu.ac.th/internship/intern-api",
});
